 
export const base_url = "https://backend.carmanautoske.com/api/";
   
 //export const base_url = "http://localhost:8805/api/";
   
